module.exports = __webpack_public_path__ + "static/media/37.f121f030.png";